import React, { useState } from "react";

function About() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div>
      <>
        <div >
          <div className="" >
            {/* ======== 1.1. header section ======== */}
            <header>
              <nav className="container navbar navbar-expand-lg ">
                <div className="container-fluid">
                  {/* site logo */}
                  <a className="nav-logo p-0" href="/">
                    <img src="/assets/images/new_logo.svg" alt="logo" />
                  </a>
                  {/* navigation button  */}
                  <button
                    className="navbar-toggle"
                    onClick={toggleNavbar}
                    type="button"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                  >
                    <i className="fa-solid fa-bars" />
                  </button>
                  {/* navigation bar manu  */}
                  <div
                    className={`mobileNav collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav d-flex justify-content-center align-items-center gap-lg-2 gap-md-2 gap-sm-2 gap-2 mb-2 mb-lg-0">
                      <li className="nav-item">
                        <a className="nav-link active" href="/">
                          Home
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="/aboutus">
                          About us
                        </a>
                      </li>
                      {/*
            <li className="nav-item">
              <a className="nav-link" href="/feature">
                Solutions
              </a>
            </li>*/}
                      <li className="nav-item">
                        <a className="nav-link" href="/Contactus">
                          Contact Us
                        </a>
                      </li>

                      {/* <li className="nav-item">
              <a className="nav-link" href="/FAQ">
                FAQ's
              </a>
            </li>*/}
                      {/* <li className="dropdown">
        <a className="nav-link " href="#">
          Pages <i className="fa-sharp fa-solid fa-sort-down" />
        </a>
        <ul className="dropdown-menu">
          <li>
            <a className="dropdown-item" href="pricing.html">
              Pricing
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="contact.html">
              Contact
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="team.html">
              Team
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="testimonials.html">
              Testimonials
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="blogs.html">
              Blogs
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="faq.html">
              FAQ
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="404.html">
              404
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="coming.html">
              Coming Soon
            </a>
          </li>
        </ul>
      </li> */}
                      {/* <li className="nav-item">
        <a id="search-bar-bt" className="nav-link" href="#">
          <i className="fa-solid fa-magnifying-glass" />
        </a>
      </li> 

            <a className=" btn-hover4" href="#">
              Create Account
            </a>*/}

                      {/* <li
        className="nav-item"
        onclick="if (!window.__cfRLUnblockHandlers) return false; open_right_side()"
        data-cf-modified-2a89ad8e51888e2ea151ec41-=""
      >
        <a className="nav-link" href="#">
          <i className="fa-sharp fa-solid fa-bars" />
        </a>
      </li> */}
                    </ul>
                  </div>
                </div>
              </nav>
              {/*============ navigation left slidebar================*/}
              <aside>
                <div id="mySidenav" className="sidenav">
                  <div className="side-nav-logo d-flex justify-content-between align-items-center ps-4 pe-3">
                    <figure className="navbar-brand">
                      <a href="/">
                        <img
                          src="/assets/images/new_logo.svg"
                          alt="img"
                          className="nav-logo"
                        />
                      </a>
                    </figure>
                    <div
                      className="closebtn"
                      onclick="if (!window.__cfRLUnblockHandlers) return false; closeNav()"
                      data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                    >
                      <i className="fa-solid fa-square-xmark side-bar-close-btn" />
                    </div>
                  </div>
                  <ul>
                    <li className="nav-item">
                      <a className="nav-link" aria-current="page" href="/">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="about.html">
                        About
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/feature">
                        Solutions
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="pricing.html">
                        Pricing
                      </a>
                    </li>
                    <li className="nav-item">
                      <div
                        className="d-flex align-items-center justify-content-between pt-3"
                        id="slid-btn"
                      >
                        <button className="a-slid">Pages</button>
                        <i className="fa-solid fa-caret-down pe-4" />
                      </div>
                      <ul id="slid-drop" className="myst">
                        <li>
                          <a href="contact.html">Contact</a>
                        </li>
                        <li>
                          <a href="team.html">Team</a>
                        </li>
                        <li>
                          <a href="testimonials.html">Testimonials</a>
                        </li>
                        <li>
                          <a href="blogs.html">Blogs</a>
                        </li>
                        <li>
                          <a href="faq.html">FAQ</a>
                        </li>
                        <li>
                          <a href="404.html">404</a>
                        </li>
                        <li>
                          <a href="coming.html">Coming Soon</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </aside>
              {/*================== navigation drop search bar================*/}
              <div className="search" id="search-bar">
                <form className="d-flex nav-search">
                  <input type="text" name="search" placeholder="Enter your text" />
                  <button className="btn-hover1" type="submit">
                    Search
                  </button>
                </form>
                <button id="remove-btn">
                  <i className="fa-solid fa-square-xmark " />
                </button>
              </div>
              {/*=================navigation Right slidebar==================*/}
              <section className="right-sidbar" id="right_side">
                <div className="d-flex justify-content-between align-items-center">
                  {/* site logo */}
                  <a className="p-0 " href="/">
                    <img src="/assets/images/new_logo.svg" alt="logo" />
                  </a>
                  <button
                    className="close_right_sidebar fa-solid fa-xmark"
                    onclick="if (!window.__cfRLUnblockHandlers) return false; close_right_sade()"
                    data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                  >
                    {" "}
                  </button>
                </div>
                <p className="mt-4 pb-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                  eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <a href="#" className="btn-hover1">
                  Discover More
                </a>
                <hr />
                <h5 className="mt-4 mb-4">Connected details:</h5>
                <ul className="d-flex flex-column gap-3">
                  <li>
                    <a href="#">
                      {" "}
                      <i className="fa-solid fa-phone" />
                    </a>
                    <a href="#">
                      <span
                        className="__cf_email__"
                        data-cfemail="71081e04031f101c1431141c10181d5f121e1c"
                      >
                        [email&nbsp;protected]
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-solid fa-envelope" />
                    </a>
                    <a href="#">+123-456-7890</a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-solid fa-clock" />
                    </a>
                    <a href="#">
                      Office Hours: 8AM - 11PM Sunday - Weekend Day
                    </a>
                  </li>
                </ul>
                <span className="d-flex gap-4 mt-4">
                  <a href="#" className="p-0">
                    <i className="fa-brands fa-facebook" />
                  </a>
                  <a href="#" className="p-0">
                    <i className="fa-brands fa-instagram" />
                  </a>
                  <a href="#" className="p-0">
                    <i className="fa-brands fa-twitter" />
                  </a>
                </span>
              </section>
            </header>
            {/* ======== End of 1.1. header section ========  */}
            {/* ======== 2.1. hero section ========  */}
            <section>
              <div className="about-hero container">


                <div className="services pb-lg-4 pb-md-2 pb-sm-0 pb-0 mb-lg- mb-md-1 mb-sm-0 mb-0">
                  <div className="container" >
                    <div className="row d-flex  ">
                      <div className=" px-3 " data-aos="fade-up" >
                        <h1 className="text-left text-black">About Us</h1>
                        <h2 className="text-lg-start text-md-start text-sm-center text-center uppercase mt-3">
                          FINANCIAL GOALS ARE OUR PRIORITY
                        </h2>
                        <p className="text-lg-start text-md-start text-sm-center text-center mt-lg-4 mt-md-2 mt-sm-2 mt-2 pb-4 ">
                          We are a team of passionate professionals with decades of proven track record in managing and growing financial institutions.<br /><br />
                          Finkeypay was started with an objective of providing the industry with new age fin-tech solutions that are secure, easy to use and yet cost-effective. Through these solutions, Finkeypay is transforming the way small and medium businesses manage their business finances.<br /><br />
                          Finkeypay is headquartered in Hyderabad, India and is one of the fastest growing fintech companies in the region.
                        </p>
                        <div className="serives-btn justify-content-md-start justify-content-ms-center justify-content-center d-flex pt-lg-4 pt-md-2 pt-sm-2 pt-2" style={{ opacity: 0 }}>
                          <a className="btn-hover2" href="#">
                            Get The Card
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </section>
            {/* ======== 2.1. hero section ========  */}
          </div>
        </div>
        {/* ======== 1.4. finance section ========  */}
        <section className="finance mt-lg-4 mt-md-2 mt-sm-0 mt-0">
          <div className="container text-center">
            <h2>UNLOCKING THE POWER OF DIGITAL PAYMENTS</h2>
            <p className="mt-0">
              Expanding financial inclusion with cutting-edge payment solutions.
            </p>
            <div className="finanes-card row gap-md-0 gap-sm-4 gap-4">
              <div className="col-lg-4 col-md-4 d-flex justify-content-center pe-lg-3 pe-md-0 pe-sm-3 pe-3">
                <div className="fin-card" data-aos="flip-up">

                  <img src="/assets/New/Figure.svg" alt="praph" />
                  <h4>Market Share</h4>
                  <p className="p-f-s">
                    Expanding financial inclusion with cutting-edge payment solutions.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 d-flex justify-content-center pe-lg-3 pe-md-0 pe-sm-3 pe-3">
                <div className="fin-card" data-aos="flip-up">

                  <img src="/assets/New/Figure (1).svg" alt="doller" />

                  <h4>Easy Payment</h4>
                  <p className="p-f-s">
                    Instant, secure, and user-friendly payment experience.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 d-flex justify-content-center">
                <div className="fin-card" data-aos="flip-up">

                  <img src="/assets/New/Figure (2).svg" alt="arow" />

                  <h4>Awesome Services</h4>
                  <p className="p-f-s">
                    From e-commerce to peer-to-peer transfers, Finkey Pay has you covered.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.4. finance section ========  */}
        {/* ======== 1.5. ispsum section ========  */}
        <h3 className="text-center">Trusted By</h3>
        <div className="ispsum-logo">
          <div className="container">
            <hr />
            <div className="logo_ispsum_slider">
              <a href="#">
                <figure>
                  <img src="/assets/marquee/1.Clarion.png" alt="img" />
                </figure>
              </a>
              <a href="#" className="d-flex items-center">
                <figure>
                  <img src="/assets/marquee/2.destiny.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/3.National.jpeg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/4.Universal.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/5.Ironhill.png" alt="img" />
                </figure>
              </a>
              <a href="#" className="d-flex items-center">
                <figure>
                  <img src="/assets/marquee/6.Afro-asian.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/7.Navabhoomi.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/8.Royal.jpeg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/9.destiny-world-logo03.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/10.Greeco.jpeg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/11.TSG.jpg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/12.Universal_Foods.jpeg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/13.Zythum.jpg" alt="img" />
                </figure>
              </a>
            </div>
            <hr />
          </div>
        </div>
        {/* ======== End of 1.5. ispsum section ========  */}
        {/* ======== 2.2. banner section ========  */}
        <section>
          <div className="container about-banner" data-aos="zoom-in">
            <div className="d-flex flex-lg-row flex-column align-items-center justify-content-center">
              {/* Image container */}
              <div className="col-lg-6 col-12 text-center mb-4 mb-lg-0">
                <img
                  src="/assets/New/Hands2.svg"
                  alt="Hands"
                  className="img-fluid w-100"
                />
              </div>

              {/* Text container */}
              <div className="col-lg-6 col-12 text-lg-start text-center px-lg-5 px-md-4 px-sm-3 px-2">
                <h3 className="text-dark">
                  Replacing complexity <br /> with simplicity
                </h3>
                <p className="p-f-s text-white">
                  Finkey Pay is designed to eliminate payment barriers and streamline financial interactions. Whether you're shopping online, sending money to loved ones, or managing business transactions, we make it effortless and secure.
                </p>
                {/*
                <div className="visa-btn">
                  <a className="btn-hover1" href="#">
                    Get The Card
                  </a>
                </div>*/}
              </div>
            </div>
          </div>


        </section>
        {/* ========End of 2.2. banner section ========  */}
        {/* ======== 1.6. gateway section ========  */}
        <section className="gateway">
          <div className="container">
            <div className="row gap-lg-0 gap-md-0 gap-sm-4 gap-4">
              <div
                className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center"
                data-aos="fade-up"
              >
                <div className="mt-5">
                  <img
                    src="/assets/New/Figure → gateway-1.png.svg"
                    alt="gate_img1"
                    className="moving img-fluid w-100"
                  />
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6  text-md-start text-sm-center text-center"
                data-aos="fade-down"
              >
                <h2>SIMPLIFY YOUR PAYMENT PROCESSES</h2>
                <p className="pt-lg-4 pt-md-3 pt-sm-2 pt-2">
                  Managing payments shouldn’t be complicated. With Finkey Pay, you can create an account in minutes, configure your user preferences, and enjoy full access to a seamless financial ecosystem..
                </p>
                <div className="gate mt-md-3 mt-sm-0 mt-4   d-flex flex-md-row flex-sm-column flex-column align-items-center">
                  <figure className="d-flex align-items-center">
                    <img src="assets/images/icon/gate-icon1.png" alt="gate-img1" />
                  </figure>
                  <div className="ms-lg-3 ms-md-3 ms-sm-0 ms-0">
                    <h5 className="pb-2">Create Account</h5>
                    <p className="p-f-s">
                      Sign up effortlessly and start transacting instantly.
                    </p>
                  </div>
                </div>
                <div className="gate d-flex mt-4  flex-md-row flex-sm-column flex-column align-items-center">
                  <figure className="d-flex align-items-center">
                    <img src="assets/images/icon/gate-icon2.png" alt="gate-img2" />
                  </figure>
                  <div className="ms-lg-3 ms-md-3 ms-sm-0 ms-0">
                    <h5 className="pb-2">User Configuration</h5>
                    <p className="p-f-s">
                      Customize payment options to match your needs.
                    </p>
                  </div>
                </div>
                <div className="gate d-flex mt-4  flex-md-row flex-sm-column flex-column align-items-center">
                  <figure className="d-flex align-items-center">
                    <img src="assets/images/icon/gate-icon3.png" alt="gate-img3" />
                  </figure>
                  <div className="ms-lg-3 ms-md-3 ms-sm-0 ms-0">
                    <h5 className="pb-2">Enjoy Full Access</h5>
                    <p className="p-f-s">
                      Experience hassle-free transactions anytime, anywhere..
                    </p>
                  </div>
                </div>
                <div className="gate-link text-lg-start text-md-start text-sm-center text-center">
                  <a className="btn-hover1" href="https://finkey-dash.paytring.com/login">
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.6. gateway section ========  */}
        {/* ======== 2.3. round-word section ========  
        <section className="round-word">
          <div className="container">
            <div className="row gap-lg-0 gap-md-0 gap-sm-4 gap-4">
              <div
                className="col-lg-6 col-md-6 d-flex align-items-lg-start align-items-md-start align-items-ms-center align-items-center justify-content-center flex-column"
                data-aos="fade-up"
              >
                <h2 className="text-lg-start text-md-start text-sm-center text-center">
                  WE ARE ROUND THE WORLD
                </h2>
                <p className="text-lg-start text-md-start text-sm-center text-center">
                  Our platform connects people across the globe, fostering meaningful interactions and innovative solutions.
                </p>
                <div className="d-flex gap-3">
                  <div className="sticker">
                    <div className="d-flex">
                      <h3 className="count">100</h3>
                      <h3>K+</h3>
                    </div>{" "}
                    <span>Active User</span>
                  </div>
                  <div className="sticker st-bg">
                    <div className="d-flex">
                      <h3 className="count">400</h3>
                      <h3>K+</h3>
                    </div>{" "}
                    <span>App Dwonload</span>
                  </div>
                </div>
                <div className="d-flex gap-3">
                  <div className="sticker st-bg">
                    <div className="d-flex">
                      <h3 className="count">90</h3>
                      <h3>%</h3>
                    </div>{" "}
                    <span>Satisfied user</span>
                  </div>
                  <div className="sticker">
                    <div className="d-flex">
                      <h3 className="count">200</h3>
                      <h3>+</h3>
                    </div>{" "}
                    <span>Partners Joined</span>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center"
                data-aos="fade-down"
              >
                <figure>
                  <img src="/assets/New/image 6.svg" alt="img" />
                </figure>
              </div>
            </div>
          </div>
        </section>*/}
        {/* ========End of 2.3. round-word section ========  */}
        {/* ======== 2.4. behind section ========  */}
        {/* <section className="behind b-back">
    <div className="container">
      <h2 className="text-center">HOW'S BEHIND</h2>
      <p className="b-para">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique nam
        recusandae vel! thanks
      </p>
      <div className="row gap-md-0 gap-sm-4 gap-4 mt-3">
        <div className="col-lg-6 col-md-6 d-flex" data-aos="flip-up">
          <div>
            <img src="assets/images/about/behind2.jpg" alt="img" />
          </div>
          <div className="ps-4">
            <h4>Pamela Brown</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab
              dolore voluptate aut?
            </p>
            <div className="b-icon">
              <a href="#">
                <i className="fa-brands fa-facebook-f" />
              </a>
              <a href="#">
                <i className="fa-brands fa-whatsapp" />
              </a>
              <a href="#">
                <i className="fa-brands fa-instagram" />
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 d-flex" data-aos="flip-up">
          <div>
            <figure>
              <img src="assets/images/about/behind.jpg" alt="img" />
            </figure>
          </div>
          <div className="ps-4">
            <h4>Emma White</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab
              dolore voluptate aut?
            </p>
            <div className="b-icon">
              <a href="#">
                <i className="fa-brands fa-facebook-f" />
              </a>
              <a href="#">
                <i className="fa-brands fa-whatsapp" />
              </a>
              <a href="#">
                <i className="fa-brands fa-instagram" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> */}
        {/* ======== End of 2.4. behind section ========  */}
        {/* ======== 1.10. profaessional section ========  */}
        <section className="profaessional mt-lg-5 mt-md-3 mt-sm-3 mt-3">
          <div className="container">
            <h2 className="text-center">Trusted By Professionals</h2>
            <p className="text-center pt-3 pb-5 mb-2">
              Our platform is endorsed by industry experts:
            </p>
            <div className="prof-size" data-aos="zoom-in-up">
              <div className="prof-slider ">
                <div className="prof-slide position-relative">
                  <div>
                    <div className="d-flex  align-items-center justify-content-center">
                      <img
                        src="assets/images/slider/profational2.png"
                        alt="img"
                        className="prof-img-2"
                      />
                    </div>
                    <div>
                      <img
                        src="assets/images/slider/Comma.png"
                        alt="img"
                        className="prof-img-1"
                      />
                    </div>
                    <p className="text-center p-f-s">
                      "Using this platform has revolutionized how I connect with my global network. The seamless user experience is outstanding!"
                    </p>
                    <div className="prof-star pt-2 pb-2 text-center">
                      <span className="stars text-lg-start">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <h5 className="text-center">Johnny Stone</h5>
                    <p className="text-center pt-2 pb-5 p-f-s">Entrepreneur</p>
                  </div>
                </div>
                <div className="prof-slide position-relative">
                  <div>
                    <div className="d-flex  align-items-center justify-content-center">
                      <img
                        src="assets/images/slider/profactional3.png"
                        alt="img"
                        className="prof-img-2"
                      />
                    </div>
                    <div>
                      <img
                        src="assets/images/slider/Comma.png"
                        alt="img"
                        className="prof-img-1"
                      />
                    </div>
                    <p className="text-center p-f-s">
                      "This app provides a game-changing way to collaborate with professionals worldwide. Highly recommended!"
                    </p>
                    <div className="prof-star pt-2 pb-2 text-center">
                      <span className="stars text-lg-start">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <h5 className="text-center">Stephen Stewart</h5>
                    <p className="text-center pt-2 pb-5 p-f-s">Entrepreneur</p>
                  </div>
                </div>
                <div className="prof-slide position-relative">
                  <div>
                    <div className="d-flex  align-items-center justify-content-center">
                      <img
                        src="assets/images/slider/profacitional.png"
                        alt="img"
                        className="prof-img-2"
                      />
                    </div>
                    <div>
                      <img
                        src="assets/images/slider/Comma.png"
                        alt="img"
                        className="prof-img-1"
                      />
                    </div>
                    <p className="text-center p-f-s">
                      "Security and ease of use are top-notch. It’s my go-to platform for professional networking."
                    </p>
                    <div className="prof-star pt-2 pb-2 text-center">
                      <span className="stars text-lg-start">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <h5 className="text-center">Tom Hiddellon</h5>
                    <p className="text-center pt-2 pb-5 p-f-s">Entrepreneur</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.10. profaessional section ========  */}
        {/* ======== 1.13. footer section ========  */}
        <footer className="position-relative">
          <div className="container">
            <h4 className="text-center">SUBSCRIBE OUR NEWSLETTER</h4>
            <p className="text-center pt-2 pb-3">Get latest News and Updates</p>
            <form
              className="d-flex align-items-center justify-content-center"
              id="footer-sub2"
            >
              {/* form Subscribe massage */}
              <div id="Succes-box2" />
              <div className="d-flex footer-search">
                <input
                  type="email"
                  name="search"
                  placeholder="Enter your Email"
                  required=""
                />
                <button type="submit" className="btn-hover1">
                  Subscribe
                </button>
              </div>
            </form>
            <div className="footer-logo text-center pb-lg-4 pb-md-3 pb-sm-2 pb-4">
              {/* footer logo  */}
              <a href="/">
                <figure>
                  <img src="/assets/images/new_logo.svg" alt="img" />
                </figure>
              </a>
            </div>
            <ul className="d-flex align-items-center justify-content-center">
              {/*<li>
                <a className="foot" href="/feature">Solutions</a>
              </li>*/}
              <li>
                <a className="foot" href="/Contactus">Contact Us</a>
              </li>
              <li>
                <a className="foot" href="/aboutus">About us</a>
              </li>
              {/*<li>
                <a className="foot" href="/FAQ">Faq</a>
              </li>*/}
            </ul>
            <hr />
            <div className="d-flex justify-content-center footer-nav-icon">
              {/* footer social icon  
              <div className="col-lg-3 col-md-3 d-flex align-items-center justify-content-md-start justify-content-sm-center justify-content-center">
                <div className="social-icon d-flex gap-2 justify-content-md-start justify-content-sm-center justify-content-center">
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-facebook-f foot-facebook" />
                  </a>
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-twitter" />
                  </a>
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-instagram" />
                  </a>
                </div>
              </div>
              */}
              {/* footer terms privacy  */}
              <div className="col-lg-6 col-md-6 d-flex justify-content-center align-items-center">
                <div className=" d-flex gap-3 p-2">
                  <a target="_blank" href="/assets/pdfs/Terms&Condition_Finkey.pdf" className="footer-terms">Terms &amp; Condition</a>
                  <a target="_blank" href="/assets/pdfs/Privacy_Policy_Finkey.pdf" className="footer-terms" >Privacy Policy</a>
                  <a target="_blank" href="/assets/pdfs/Refund_Policy_Finkey.pdf" className="footer-terms" >Refund Policy</a>
                </div>
              </div>
              {/* footer logo slider  */}
            </div>
            <hr />
            <div className="Copyright d-flex justify-content-between flex-wrap dir">
              <a className="footer-copyright">Copyright © 2024 FinkeyPay. All Right Reserved.</a>
              <a className="footer-copyright">FinkeyPay</a>
            </div>
          </div>
        </footer>
      </>

    </div>
  )
}

export default About
